export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
     
      <div className="hero--section--content--box about--section--box text-black">
        <div className="hero--section--content">
          {/* <p className="section--title">
                        About Me
                    </p> */}
          <h2 className="section--heading" data-aos="fade-up" data-aos-offset="300" data-aos-easing="ease-in-sine">About Me</h2>
          <p className="hero--section-description" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
            Hi, I’m Samrudhi Margi, a passionate UI/Frontend Developer with over
            a decade of experience in the tech industry. I specialize in
            creating responsive, high-performance web applications using modern
            web technologies like React.js, HTML5, CSS3, JavaScript, Sass,
            Bootstrap, and jQuery.
          </p>

          <p className="hero--section-description" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
            Throughout my career, I’ve had the privilege of designing and
            developing intuitive, user-centric web interfaces for businesses and
            organizations around the globe. I focus on crafting seamless user
            experiences, ensuring accessibility, and optimizing performance for
            both desktop and mobile platforms.
          </p>

          <p className="hero--section-description" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
            With a solid foundation in cross-browser compatibility, UI
            optimization, and continuous learning, I thrive on solving complex
            problems and turning ideas into functional, visually appealing web
            applications. I also bring strong collaboration and communication
            skills, often working alongside design teams to bring pixel-perfect
            designs to life.
          </p>

          <p className="hero--section-description" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
            I’m always excited about new opportunities to leverage my skills and
            contribute to innovative projects. When I’m not coding, I’m learning
            something new or enjoying a good challenge. Feel free to explore my
            portfolio and connect with me!
          </p>
        </div>
      </div>
      {/* <div className="about--section--img">
        <img src="./img/about-me-1.png" alt="about me image" />
      </div> */}
    </section>
  );
}
